<style lang="scss" src='./Header.scss'></style> <!-- Global Style -->
<template src="./Header.html"></template>

<script>

export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      required: true,
    },
    rightText: {
      type: String,
      required: false,
    },
    showBack: {
      type: Boolean,
      required: false,
    },
    onBack: {
      type: Function,
      required: false,
    }
  },
  data() {
    return ({
    });
  },
  computed: {
  },

  methods: {
    
    back() {
      if (this.onBack) {
        this.onBack();
      } else {
        this.$router.go(-1);
      }
    }

  },
  mounted() {
  },
};
</script>